(function () {
  'use strict';

  var button = document.getElementById('AmaiWhatsApp');
  var configElement = document.getElementById('AmaiWhatsAppConfig');
  if (!button || !configElement || button.dataset.initialized === 'true') return;
  button.dataset.initialized = 'true';

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return; // O link permanece oculto se a configuração não for válida.
  }
  if (!config || typeof config.phone !== 'string' || !/^\d{8,15}$/.test(config.phone)) return;

  function normalizePath(path) {
    return path.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  }

  function matchesPath(pattern, path) {
    if (typeof pattern !== 'string' || !pattern.trim()) return false;
    pattern = normalizePath(pattern.trim());
    var wildcard = pattern.indexOf('*');
    if (wildcard === -1) return path === pattern;
    if (wildcard !== pattern.length - 1) return false;
    return path.indexOf(pattern.slice(0, -1)) === 0;
  }

  function listMatches(list, predicate) {
    return Array.isArray(list) && list.some(predicate);
  }

  var path = normalizePath(window.location.pathname);
  var blocked = listMatches(config.blockedTemplates, function (template) {
    return typeof template === 'string' && template.trim() === config.template;
  }) || listMatches(config.blockedPaths, function (pattern) {
    return matchesPath(pattern, path);
  });
  var allowed = listMatches(config.allowedPageTypes, function (pageType) {
    return typeof pageType === 'string' && pageType.trim() === config.pageType;
  }) || listMatches(config.allowedPaths, function (pattern) {
    return matchesPath(pattern, path);
  });
  if (blocked || !allowed) return;

  function updateLink() {
    var message = typeof config.message === 'string' ? config.message : '';
    if (config.includePageUrl === true) {
      message += (message ? '\n' : '') + window.location.href;
    }
    var mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
    button.href = mobile
      ? 'https://wa.me/' + config.phone + '?text=' + encodeURIComponent(message)
      : 'https://web.whatsapp.com/send?phone=' + config.phone + '&text=' + encodeURIComponent(message);
  }

  updateLink();
  button.addEventListener('click', function (event) {
    updateLink();
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    // O aviso de saída do Shopify (shopify-exit-interstitial) intercepta cliques em links externos,
    // mas ignora cliques já cancelados; abrir via window.open leva o cliente direto ao WhatsApp.
    event.preventDefault();
    window.open(button.href, '_blank', 'noopener,noreferrer');
  });

  function start() {
    var delay = Number(config.delaySeconds);
    if (!Number.isFinite(delay) || delay < 0) delay = 6;
    var elapsed = navigation && navigation.domContentLoadedEventStart
      ? window.performance.now() - navigation.domContentLoadedEventStart
      : 0;
    var remaining = Math.max(0, delay * 1000 - elapsed);
    function reveal() {
      // As classes de abertura/fechamento do tema continuam impondo display:none via CSS.
      button.hidden = false;
    }
    if (remaining === 0) reveal();
    else window.setTimeout(reveal, remaining);
  }

  var navigation = window.performance && window.performance.getEntriesByType('navigation')[0];
  if (document.readyState === 'loading' ||
      (document.readyState === 'interactive' && navigation && !navigation.domContentLoadedEventStart)) {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
